import { FAQProps } from "_components/FAQs/FAQs";
import React, { PropsWithChildren } from "react";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  useAccordionItemState,
} from "@chakra-ui/react";
import { BsPlus, BsX } from "react-icons/bs";

const AccordionIcon = () => {
  const { isOpen } = useAccordionItemState();
  return isOpen ? (
    <BsX className="text-2xl lg:text-4xl" />
  ) : (
    <BsPlus className="text-2xl lg:text-4xl" />
  );
};

export default function FAQs({ items }: PropsWithChildren<FAQProps>) {
  const filtered = items.filter((item) => item.body !== "");

  return (
    <Accordion allowToggle>
      {filtered.map(({ title, body }, index) => {
        return (
          <AccordionItem key={title} mb={4}>
            <h2>
              <AccordionButton backgroundColor={"#EEEEEE"}>
                <Box
                  fontFamily="inherit"
                  as="span"
                  fontSize={{
                    base: 16,
                    lg: 24,
                  }}
                  fontWeight="medium"
                  color="prussianBlue.500"
                  flex="1"
                  textAlign="left"
                  lineHeight="shorter"
                  py={{
                    base: 2,
                    lg: 8,
                  }}
                >
                  {title}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>

            <AccordionPanel
              pb={8}
              fontSize={{
                base: 14,
                lg: 22,
              }}
              fontWeight={400}
              color="gray.600"
              textAlign="left"
              backgroundColor={"#EEEEEE"}
            >
              {body}
            </AccordionPanel>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
